<template>
    <div class="cbg-content">
        <div class="cbg-top">
            <div v-for="(item, a) in validDefaultData" :key="a">
                <div class="contentCenterTitle">{{ item.value1 }}</div>
                <div class="dl">
                    <div class="centerNum" v-for="(item, i) in +item.value3" :key="i"><span>{{ getNum(a, i) }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="bar_bg"></div>
        <div ref="cmain1" class="cmain" @mouseover="autoTimePaused = true" @mouseout="autoTimePaused = false"></div>
    </div>
</template>

<script>
import * as methods from './method.js'
export default {
    name: "template.scope117",
    props: {
        vdata: {
            type: [Array, String],
            default: () => []
        },
        jsondata: {
            type: [Array, String],
            default: () => []
        },
        scopedata: {
            type: Object,
            default: () => { }
        }
    },
    data() {
        return {
            timer: null,
            defaultdata: [
                { value1: '数据统计', value2: '11566', value3: '6', value4: '1月', value5: '570', value6: '系列一', value7: '%' },
                { value1: '数据统计2', value2: '42', value3: '3',  value4: '2月', value5: '300', value6: '系列一', },
                { value1: '数据统计3', value2: '156', value3: '3', value4: '3月', value5: '120', value6: '系列一', },
                { value1: '数据统计4', value2: '432', value3: '3', value4: '4月', value5: '430', value6: '系列一', },
                { value1: '', value2: '', value3: '', value4: '5月', value5: '370', value6: '系列一', },
                { value1: '', value2: '', value3: '', value4: '6月', value5: '370', value6: '系列一', },
                { value1: '', value2: '', value3: '', value4: '1月', value5: '470', value6: '系列二', },
                { value1: '', value2: '', value3: '', value4: '2月', value5: '270', value6: '系列二', },
                { value1: '', value2: '', value3: '', value4: '3月', value5: '570', value6: '系列二', },
                { value1: '', value2: '', value3: '', value4: '4月', value5: '170', value6: '系列二', },
                { value1: '', value2: '', value3: '', value4: '5月', value5: '270', value6: '系列二', },
                { value1: '', value2: '', value3: '', value4: '6月', value5: '370', value6: '系列二', },
            ],
            valueMap: [
                { name: '概览名称', key: "value1" },
                { name: '概览数值', key: "value2" },
                { name: '概览位数', key: "value3" },
                { name: "图表名称", key: "value4" },
                { name: '折线图数值', key: 'value5' },
                { name: '图例', key: 'value6' },
                // { name: '图例2', key: 'value7' },
                // { name: '折线图2数值', key: 'value8' },
                { name: '单位', key: 'value7' },
            ],
            exceldata: [],
            apiconfig: {},
            isApi: false,
            scope: {},
            autoTimePaused: false,
            numTotals: [], // 动态存储 numtotal 的数组
            timers: [], // 动态存储定时器的数组
            paddedNumCache: [], // 存储补零后的字符串结果
            validDefaultData: [], // 存储符合位数限制的数据
        };
    },
    beforeDestroy() {
        clearInterval(this.timer);
        this.timer = null;
    },
    watch: {
        vdata(n) {
            if (n && n.length) {
                let vdatalist = n.filter(item => {
                    let vlist = Object.keys(item)
                    let isdata = false
                    vlist.forEach(del => {
                        if (item[del] == undefined) {
                            item[del] = ''
                        } else if (del && item[del]) {
                            isdata = true
                        }
                    })
                    if (vlist.length && isdata) return item
                })
                this.defaultdata = vdatalist
            }
        },
        jsondata(n) {
            this.exceldata = n;
        },
        defaultdata() {
            this.setdata()
            this.DrawEcharts();
        }
    },
    methods: {
        ...methods,
        setdata() {
            let totalDigits = 0;
            let validIndex = 0;
            // 找出符合 18 位限制的数据项
            for (let i = 0; i < this.defaultdata.length; i++) {
                const currentDigits = +this.defaultdata[i].value3;
                if (totalDigits + currentDigits <= 18) {
                    totalDigits += currentDigits;
                    validIndex = i;
                } else {
                    break;
                }
            }
            // 截取符合条件的数据项
            this.validDefaultData = this.defaultdata.slice(0, validIndex + 1);

            if (this.validDefaultData && this.validDefaultData.length) {
                this.numTotals = this.validDefaultData.map(() => 0);
                this.paddedNumCache = this.validDefaultData.map((item) => {
                    let numStr = item.value2.toString();
                    // 如果 value2 的位数超过 value3，只取前 value3 位
                    if (numStr.length > +item.value3) {
                        numStr = numStr.slice(0, +item.value3);
                    }
                    return this.numreduce(numStr, +item.value3);
                }); // 初始化缓存数组，处理后根据 value2 和 value3 补零
                this.validDefaultData.forEach((item, i) => {
                    item.value = +item.value2 || 0;
                });
                this.validDefaultData = this.validDefaultData.filter(item => item.value3 && +item.value3 > 0)
            }
        },

        numreduce(num, len) {
            let start = "";
            let numend = num.toString();
            if (numend.length < len) {
                for (let i = 0; i < len - numend.length; i++) {
                    start = start + "0";
                }
            }
            return start + numend;
        },
        indexSumnew(index) {
            if (+this.validDefaultData[index].value !== +this.numTotals[index]) {
                let num = this.numreduce(
                    +this.validDefaultData[index].value,
                    +this.validDefaultData[index].value3
                ).split("");
                let strnum = this.numreduce(
                    +this.numTotals[index],
                    +this.validDefaultData[index].value3
                ).split("");
                strnum.forEach((del, a) => {
                    if (+del < +num[a]) {
                        strnum[a] = +del + 1;
                    }
                });
                this.numTotals[index] = strnum.join("");
                this.paddedNumCache[index] = this.numreduce(
                    this.numTotals[index],
                    +this.validDefaultData[index].value3
                ); // 更新缓存
            } else {
                clearInterval(this.timers[index]);
                this.timers[index] = null;
                setTimeout(() => {
                    this.numTotals[index] = 0;
                    this.paddedNumCache[index] = "0".repeat(
                        +this.validDefaultData[index].value3
                    ); // 重置缓存
                    this.timers[index] = setInterval(() => {
                        this.indexSumnew(index);
                    }, 300);
                }, 5000);
            }
        },
        startTimers() {
            this.timers.forEach((timer) => {
                if (timer) {
                    clearInterval(timer);
                }
            });
            this.timers = [];
            this.validDefaultData.forEach((_, index) => {
                this.timers[index] = setInterval(() => {
                    this.indexSumnew(index);
                }, 300);
            });
        },
        getNum(a, i) {
            // 检查索引是否越界
            if (a >= this.paddedNumCache.length) {
                return "0";
            }
            // 从缓存中获取补零后的字符串
            const paddedNum = this.paddedNumCache[a];
            return paddedNum[i] || "0";
        },
		DrawEcharts() {
			clearInterval(this.timer);
			this.timer = null;
			var echarts = require("echarts");
			var TmyChart = echarts.init(this.$refs.cmain1);
            let datalist = []
			let legend = [];
			let unit = this.defaultdata[0].value7 || ''
            let colormap = ['#1a87fa', '#1fe4e3', '#2a4de2', '#b1e4fd', '#0cd083', '#d0711a', '#79d02d', '#5952d1']
            let lengedmap = [...new Set(this.defaultdata.map((item) => item.value6))]
            let xAxis = [...new Set(this.defaultdata.map((item) => item.value4))]
            lengedmap.forEach((item, i) => {
                let itemdata = this.defaultdata.filter(del => del.value6 == item)
                let vlist = []
                let left = 50 - (5 * lengedmap.length)
                legend.push(
                    {
                        top: "2%",
                        left: left + 10 * i + '%',
                        itemHeight: 12, //图例的高度  文字左边那个
                        itemWidth: 10,
                        textStyle: { color: "#bdc2cb", width: 80, overflow: 'truncate' },
                        data: [{ name: item, icon: "rect" }],
                    }
                )
                itemdata.forEach(del => {
                    let item = {
                        name: del.value4,
                        value: del.value5
                    }
                    vlist.push(item)
                })
                datalist.push(vlist)
            })
            let series = datalist.map((item, i) => {
                return {
                    name: lengedmap[i],
                    type: "line",
                    smooth: false,
                    data: item,
                    itemStyle: {
                        normal: {
                            color: colormap[i] // 这里设置为红色
                        },
                    },
                }
            })
			var Toption = {
				title: [
					{
						text: unit,
						top: "0",
						left: "0",
						textStyle: {
							color: "#979AA0",
							fontSize: 12,
						},
					},
				],
				tooltip: {
					trigger: "axis",
				},
				grid: {
					left: "5px",
					right: "10px",
					bottom: "0px",
					top: "40px",
					containLabel: true,
				},
				legend: [...legend],
				xAxis: {
					type: "category",
					boundaryGap: false,
					axisTick: {
						show: false,
					},
					axisPointer: {
						type: "shadow",
					},
					axisLabel: {
						interval: 0,
						width: 50,
						overflow: 'truncate', //文字超出宽度截断，默认为...
						textStyle: {
							color: "#bdc2cb", // 这里将 x 轴文本颜色设为红色
							fontSize: "14",
							lineHeight: 16,
						},
					},
					axisLine: {
						lineStyle: {
							// X 轴颜色配置
							color: "#4792e9",
						},
					},
					splitLine: {
						show: true,
						lineStyle: {
							type: "dashed",
							color: "rgba(231,241,251,.2)",
						},
					},
					data: xAxis,
				},
				yAxis: {
					type: "value",
					splitNumber: 4,
					axisLabel: {
						textStyle: {
							color: "#bdc2cb", // 这里将 x 轴文本颜色设为红色
						},
						fontSize: 14,
					},
					axisLine: {
						show: false,
					},
					splitLine: {
						show: true,
						lineStyle: {
							type: "dashed",
							color: "rgba(231,241,251,.2)",
						},
					},
				},
				series: [...series],
			};
			Toption && TmyChart.setOption(Toption);
			this.timer = setInterval(() => {
				if (this.autoTimePaused) return; // 如果定时器暂停，则不执行后续逻辑
				TmyChart.clear();
				Toption && TmyChart.setOption(Toption);
			}, 5000);
		},
    },
    mounted() {
        if (this.vdata && this.vdata.length) {
            this.defaultdata = this.vdata;
        }
        if (this.jsondata && this.jsondata.length) {
            this.exceldata = this.jsondata;
        }
        this.setData()
        this.setdata()
        this.DrawEcharts();
    }
};
</script>

<style scoped lang="scss">
.cbg-content {
    height: 600px;
    pointer-events: auto;

    .cbg-top {
        width: 100%;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        column-gap: 28px;
    }

    .contentCenterTitle {
        font-size: 16px;
        color: #fff;
    }

    .centerNum {
        width: 41px;
        width: 41px;
        height: 54px;
        background: url(../../assets/template/num-bg.png) no-repeat;
        background-size: 100%;
        margin: 4px 6px 0 0;
        font-family: "lcdd";
        font-size: 45px;
        color: #fff;
        line-height: 50px;
        text-align: left;

        span {
            font-family: YeJinShuZi;
            padding-left: 7px;
        }
    }

    .dl {
        display: flex
    }

    .bar_bg {
        width: 1117px;
        height: 180px;
        background: url("../../assets/temimg11/bar_bg.png") no-repeat center center;
        background-size: 100% 100%;
        position: absolute;
        bottom: 0;
        left: calc(50% - 558.5px);
    }

    .lt-left {
        width: 357px;
        height: 358px;
        position: absolute;
        left: calc(49.5% - 371px);
        top: calc(50% - 159px);
        box-sizing: border-box;
        background: url("../../assets/temimg11/bar_cen.png") no-repeat;
        background-size: 100%;
    }

    .cmain {
        width: 95%;
        height: calc(100% - 200px);
        margin: 0 auto;
    }

    .center_text {
        position: absolute;
        top: 54%;
        left: 29%;
        transform: translate(-50%, -50%);
        text-align: center;
        font-family: Source Han Sans CN;
        font-weight: 500;
        font-size: 41px;
        color: #ffffff;
        line-height: 48px;

        span {
            max-width: 140px;
            display: block;
            white-space: nowrap;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 21px;
            color: #ffffff;
            line-height: 48px;
        }
    }
}
</style>